import __request__ from "routing/request";
export function get(streamid) {
  return __request__("GET", `/streams/${streamid}/rules`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function create(streamid, JSONbody) {
  return __request__("POST", `/streams/${streamid}/rules`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function types(streamid) {
  return __request__("GET", `/streams/${streamid}/rules/types`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getBystreamidAndstreamRuleId(streamid, streamRuleId) {
  return __request__("GET", `/streams/${streamid}/rules/${streamRuleId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function update(streamid, streamRuleId, JSONbody) {
  return __request__("PUT", `/streams/${streamid}/rules/${streamRuleId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(streamid, streamRuleId) {
  return __request__("DELETE", `/streams/${streamid}/rules/${streamRuleId}`, null, {}, {
    "Accept": []
  });
}
